import { useState, useEffect } from "react";
import { useApi } from "../../hooks/use-api";
import { useSingleton } from "../../hooks/use-singleton";
import { apiLeaderBoard } from "../../utils/api-routes";

export const useHandler = ({ roomCode, skipApi = false }) => {
  const { get, post } = useApi();
  const [finalScores, setFinalScores] = useState(null);

  useEffect(() => {
    if (roomCode) {
      getFinalScores();
    }
  }, [roomCode]);

  const getFinalScores = async () => {
    try {
      const res = await get(apiLeaderBoard(roomCode));

      console.log(res, "final result response");

      setFinalScores(res?.data);
    } catch (e) {
      console.log("Error on getting final result", e);
    }
  };

  return { getFinalScores, finalScores };
};
